export default __webpack_public_path__ + "static/couple1-ebf6ed78f9df61f7d859f57041a68ca8.png";